import { doDelApplication} from '../firebase/db'
import { FETCH_MYAPPLICATIONS } from '../constants/actionTypes'
import _ from 'lodash'
const INITIAL_STATE = {
    myApplications: [],
    userId: null,
    currentOpen: null,
  };

  const applyFetchMyApplications = (state, action) => {

    return ({
    ...state,
    myApplications: action.payload ? _.values(action.payload) : []
  })
}

function applyDeleteApplication(state, action) {
  const {eventIndex, userId} = action.payload
  const clone = Object.assign({}, state);
  clone.eventIds.splice(action.payload.eventIndex, 1);
  doDelApplication(eventIndex, userId)
  return clone;
}

const applyApplicationDetails = (state, action) =>{
  return ({
    ...state,
    currentOpen: action.payload
  })
}

  function applicationReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
      case 'ADD_APPLICATION' : {
       return ({
         ...state,
         myApplications: action.payload
       })
      }
      case FETCH_MYAPPLICATIONS : {
        return applyFetchMyApplications(state, action);
      }
      case 'DELETE_APPLICATION' : {
        return applyDeleteApplication(state, action);
      }
      case 'FETCH_APPLICATION_DETAILS' : {
        return applyApplicationDetails(state, action)
      }
      default : return state;
    }
  }
  
  export default applicationReducer;


// WEBPACK FOOTER //
// ./src/reducers/application.js